import {
  Badge,
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  HStack,
  Text
} from '@chakra-ui/react'
import { FC, useState } from 'react'
import { BiLike, BiDislike } from 'react-icons/bi'

import {
  Article,
  categoryColors,
  categoryLabels,
  ARTICLES_WITH_VIDEO
} from '@base/variables/help-center/articles'

interface ArticleDetailProps {
  article: Article | null
  isOpen: boolean
  onClose: () => void
  onNavigate: (articleId: string) => void
}

const ArticleDetail: FC<ArticleDetailProps> = ({
  article,
  isOpen,
  onClose,
  onNavigate
}) => {
  const [feedback, setFeedback] = useState<'up' | 'down' | null>(null)

  if (!article) return null

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
      <DrawerOverlay bg="blackAlpha.300" />
      <DrawerContent bg="white">
        <DrawerCloseButton />
        <DrawerHeader borderBottomWidth="1px" pb={4}>
          <Badge
            colorScheme={categoryColors[article.category]}
            borderRadius="full"
            px={2}
            mb={2}
          >
            {categoryLabels[article.category]}
          </Badge>
          <Text fontSize="xl" fontWeight="700" color="gray.800">
            {article.title}
          </Text>
          <Text fontSize="sm" color="gray.500" mt={1}>
            {article.summary}
          </Text>
        </DrawerHeader>
        <DrawerBody py={6}>
          {ARTICLES_WITH_VIDEO.has(article.id) && (
            <Box mb={6}>
              <Text fontSize="sm" fontWeight="600" color="gray.600" mb={2}>
                Tutorial em vídeo
              </Text>
              <video
                src={`/videos/${article.id}.mp4`}
                controls
                preload="metadata"
                style={{
                  width: '100%',
                  borderRadius: '8px',
                  aspectRatio: '16/9',
                  display: 'block'
                }}
              />
            </Box>
          )}
          <Box
            whiteSpace="pre-wrap"
            fontSize="sm"
            color="gray.700"
            lineHeight="1.8"
          >
            {article.content}
          </Box>

          <Box mt={8} pt={6} borderTop="1px solid" borderColor="gray.100">
            <Text fontSize="sm" fontWeight="600" color="gray.600" mb={3}>
              Esta resposta ajudou?
            </Text>
            <HStack spacing={3}>
              <Button
                size="sm"
                leftIcon={<BiLike />}
                variant={feedback === 'up' ? 'solid' : 'outline'}
                colorScheme="green"
                onClick={() => setFeedback('up')}
              >
                Sim
              </Button>
              <Button
                size="sm"
                leftIcon={<BiDislike />}
                variant={feedback === 'down' ? 'solid' : 'outline'}
                colorScheme="red"
                onClick={() => setFeedback('down')}
              >
                Não
              </Button>
            </HStack>
            {feedback && (
              <Text fontSize="xs" color="gray.400" mt={2}>
                Obrigado pelo feedback!
              </Text>
            )}
          </Box>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  )
}

export default ArticleDetail
